<ng-container>
  @if (welfareCheckConfiguredUserTotalCountBackup > 7) {
    <div class="my-3">
      <gtapp-auto-complete
        [data]="assigneeSearchList"
        placeHolder="Filter Guard"
        searchKeyword="full_name"
        [itemTemplate]="assigneeTemplate"
        (inputChanged)="searchAssignee($event)"
        [enableCloseOption]="true"
        (fieldCleared)="getUserWelfareChecksConfiguredData()"
      >
      </gtapp-auto-complete>
      <ng-template #assigneeTemplate let-guard> </ng-template>
    </div>
  }
  @for (user of configuredWelfareCheckListData; track user) {
    <div class="my-2">
      <div
        class="p-2"
        [ngClass]="
          user?.saveChanges && user?.is_active
            ? 'border-warning border rounded'
            : 'border bg-body-secondary'
        "
      >
        <div class="row row-cols-2 row-cols-lg-6 justify-content-center">
          <div
            class="d-flex align-items-center col-12 col-lg-2 fw-semibold ps-2"
          >
            {{ user?.full_name }}
          </div>
          <div class="d-flex align-items-center col justify-content-center">
            @if (userJobWelfareCheckConfiguredData?.[user?.id]?.length) {
              <div
                routerLink="/schedule"
                class="w-100 rounded text-center p-2 cursor-pointer fw-semibold"
                [ngClass]="
                  !user?.signed_in
                    ? 'border border-danger text-danger bg-body'
                    : 'border border-success text-success bg-body'
                "
              >
                {{ !user?.signed_in ? "Inactive" : "Active" }}
                <span class="float-end text-secondary"
                  ><i class="fa-solid fa-pen-to-square"></i
                ></span>
                @if (!user?.signed_in) {
                  @if (!user?.signed_in) {
                    <div class="small-font">Person Not Signed In</div>
                  }
                } @else {
                  <div class="small-font">Enabled via Roster</div>
                }
              </div>
            } @else {
              @switch (user?.status) {
                <!--https://app.shortcut.com/sendem/story/7077/welfare-checks-by-guard#activity-9852-->
                @case (0) {
                  <div
                    class="w-100 rounded text-center p-2 border border-secondary bg-body py-3"
                  >
                    Inactive
                  </div>
                }
                @case (1) {
                  <div
                    class="w-100 rounded text-center p-2 bg-success text-white py-3 fw-semibold"
                  >
                    Active
                  </div>
                }
                @case (2) {
                  <div
                    class="w-100 rounded text-center p-2 fw-semibold bg-danger text-white"
                  >
                    Inactive
                    <div class="small-font">Person Not Signed In</div>
                  </div>
                }
                @case (3) {
                  <div
                    class="w-100 rounded text-center p-2 border border-secondary bg-body"
                  >
                    Inactive
                    <div class="small-font">Outside Active Hours</div>
                  </div>
                }
              }
            }
          </div>
          <div class="d-flex align-items-center col">
            <div class="form-floating w-100">
              <input
                class="form-control"
                type="time"
                pattern="[0-9]{2}:00"
                title="Enter time in HH:MM format"
                placeholder="Start Time"
                [value]="user?.start_time"
                id="startTime"
                (change)="formatTime($event, 'start_time', user)"
              />
              <label for="startTime">Start Time</label>
            </div>
          </div>
          <div class="d-flex align-items-center col">
            <div class="form-floating w-100">
              <input
                class="form-control"
                type="time"
                pattern="[0-9]{2}:00"
                title="Enter time in HH:MM format"
                placeholder="End Time"
                [value]="user?.end_time"
                id="endTime"
                (change)="formatTime($event, 'end_time', user)"
              />
              <label for="endTime">End Time</label>
            </div>
          </div>
          <div class="d-flex align-items-center col">
            <div class="form-floating w-100">
              <select
                [disabled]="!user?.interval_check"
                class="form-select"
                [ngModel]="user.interval_check"
                (ngModelChange)="intervalChanged($event, user)"
                placeholder="Welfare Check Interval"
              >
                @for (interval of user?.intervalData; track interval) {
                  <option [ngValue]="interval.value">
                    {{ interval.name }}
                  </option>
                }
              </select>
              <label for="">Check Interval</label>
            </div>
          </div>
          <div
            class="col-12 col-lg-2 d-flex align-items-center justify-content-center flex-wrap"
          >
            <span class="me-2 fw-semibold">Off</span>
            <div class="form-switch py-sm-3">
              <input
                [disabled]="!user?.interval_check"
                class="form-check-input"
                type="checkbox"
                role="switch"
                [checked]="user?.is_active"
                (change)="updateWelfareCheckForUser(user, $event)"
              />
            </div>
            <span class="ms-2 pe-4 fw-semibold">On</span>
            @if (user?.saveChanges && user?.is_active) {
              <div class="pe-4">
                <span (click)="updateWelfareCheckForUser(user)">
                  <button class="btn btn-danger">Save</button>
                </span>
              </div>
            }
          </div>
        </div>
        @if (user?.errorMessage) {
          <div class="small-font fw-semibold text-end text-danger">
            {{ user?.errorMessage }}
          </div>
        }
      </div>
    </div>
  }

  <gtapp-pagination-control
    [pageSize]="welfareCheckConfiguredUserRows"
    [pageNum]="welfareCheckConfiguredUserPageNum"
    [previous]="welfareCheckConfiguredUserPrevious"
    [totalRows]="welfareCheckConfiguredUserTotalCount"
    (onClickPagination)="onChangePaginatioWelfareChecksConfigured($event)"
    (onChangePagination)="onChangePaginatioWelfareChecksConfigured($event)"
  >
  </gtapp-pagination-control>
</ng-container>
